// extracted by mini-css-extract-plugin
module.exports = {"row":"CommunityInfoSection_row__3S1Ok","label":"CommunityInfoSection_label__20u-X","value":"CommunityInfoSection_value__14n6e"};